module.exports = __webpack_public_path__ + "media/images/error-404-36ec96972d75bd2164a3b0064d6b3514.png";